import { render } from "./aboutUs.vue?vue&type=template&id=6eac1c8e&scoped=true"
import script from "./aboutUs.vue?vue&type=script&lang=js"
export * from "./aboutUs.vue?vue&type=script&lang=js"

import "./aboutUs.vue?vue&type=style&index=0&id=6eac1c8e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eac1c8e"]])

export default __exports__